import React, { useState } from 'react';
import classNames from 'classnames';
import AnimatedHandle
  from '@components/pages/ShopV3/components/Sidebar/components/Drawer/AnimatedHandle';
import Checkmark
  from '@components/pages/ShopV3/components/Filters/AttributeFamilyFilter/assets/checkmark.svg';
import { IFacetValue } from '@components/pages/ShopV3/model/SearchResults';
import useAttributeLoading from '@components/pages/ShopV3/util/useAttributeLoading';
import { useRouter } from 'next/router';
import styles
  from './AttributeFamilyFilter.module.scss';

interface IAttributeFamilyFilter {
  parent: string;
  onFilterSelected: (value: IFacetValue) => void;
  facets: IFacetValue[];
  selectedFilterIds: string[];
  classname?: string;
}

const AttributeFamilyFilter = ({
  classname,
  parent,
  facets,
  onFilterSelected,
  selectedFilterIds
}: IAttributeFamilyFilter) => {
  const router = useRouter();

  const [isOpen, setIsOpen] = useState(true);

  const loading = useAttributeLoading(router);

  const handleOpenDrawer = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  function isValueSelected(value: IFacetValue) {
    return selectedFilterIds.includes(value.id);
  }

  const filterCount = facets.reduce((prev, curr) => {
    return isValueSelected(curr) ? prev + 1 : prev;
  }, 0);

  return (
    <div className={classNames(styles.Root, classname)}>
      <div className={styles.FilterButton}>
        <AnimatedHandle
          handleDrawerOpened={handleOpenDrawer}
          isActive={isOpen}
          title={parent}
          filterCount={filterCount}
        />
      </div>
      <ul
        className={classNames(styles.FilterList, styles.TopLevel, {
          [styles.Expanded]: isOpen,
          [styles.Collapsed]: !isOpen,
        })}
      >
        {facets.map((facet) => {
          const isSelected = isValueSelected(facet);

          return (
            <li key={facet.id} className={styles.FilterItem}>
              <label
                htmlFor={facet.value}
                className={classNames(styles.Checkbox, {
                  [styles.Disabled]: loading,
                })}
              >
                <div
                  className={classNames(styles.Checkmark, {
                    [styles.Checked]: isSelected,
                  })}
                >
                  {isSelected && <Checkmark />}
                </div>
                <div className={styles.Button}>{facet.value}</div>
                <input
                  id={facet.value}
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => onFilterSelected(facet)}
                  disabled={loading}
                />
              </label>
            </li>
          );
        })}
      </ul>
      {facets.length > 5 && <div className={styles.Faded} />}
      <div className={styles.Divider} />
    </div>
  );
};

export default AttributeFamilyFilter;
